import {
  Sidebar as SidebarBase,
  SidebarHeader,
} from "@/components/atoms/Sidebar";
import { useAuth } from "@/modules/auth/features/application/hooks/useAuthQueries";
import { NavigationMenu } from "@/components/molecules/NavigationMenu/NavigationMenu";
import { useMobile } from "@/hooks/useMobile";

export const Sidebar = () => {
  const { user } = useAuth();
  const isMobile = useMobile();

  return (
    <SidebarBase>
      <SidebarHeader>
        <div className="p-2 border-b border-neutral dark:border-gray-700">
          <div className="font-semibold text-sm dark:text-white">
            {user?.name}
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-400">
            {user?.email}
          </div>
        </div>
      </SidebarHeader>

      <NavigationMenu isMobile={isMobile} />
    </SidebarBase>
  )
}